export default __webpack_public_path__ + "static/media/navLeft.e443a495.svg";